module.exports = __webpack_public_path__ + "static/force-tire-check-vid-a714b8ad4503518d8b4528be0edfd678.mp4";